<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccInptRpt3.vue
*@ 컴포넌트설명 : 자동이체 - 이체확인증
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" class="popup" @cancel="popupClose">
      <template #subtitle>
        <h2>{{ /*이체 확인증 (자동)*/ $t("MPAY-04-01-11-23") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span class="divider-date">{{ /*이체 일시*/ $t("MPAY-04-01-06-A2") }} : {{ $getGlobalDateFmt(detailInfo.sysLastPrcssYMS) }}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /*출금 정보*/ $t("MPAY-04-01-06-A3") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌번호*/ $t("MPAY-04-01-06-A4") }}</dt>
          <dd class="right">{{ detailInfo.acno }}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-04-01-07-05") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.trsaccAmt) }}</span>
          </dd>
          <dt>{{ /*수수료*/ $t("MPAY-04-01-01-07") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.trsaccTranFeeAmt) }}</span>
          </dd>
          <dt>{{ /*송금메모*/ $t("MINQ-02-02-03-13") }}</dt>
          <dd class="right">{{ detailInfo.trsaccApctRefCtnt1 }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금정보*/ $t("MPAY-04-01-06-A10") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /* 은행명 */ $t("MPAY-04-01-07-09") }}</dt>
          <dd class="right">{{ detailInfo.rcevnBnkName }}</dd>
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-01-01-15-14") }}</dt>
          <dd class="right">{{ detailInfo.draweAcno }}</dd>
          <dt>{{ /*입금 금액*/ $t("MPAY-04-01-07-11") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.trsaccAmt) }}</span>
          </dd>
          <dt>{{ /*수취인*/ $t("MPAY-01-01-15-15") }}</dt>
          <dd class="right">{{ detailInfo.draweAcnFname }}</dd>
          <dt>{{ /*Particulars*/ /*수취인 참조내용*/ siteCode == $config.SITECODE_OGAUC ? $t("MPAY-02-01-12-22") : $t("MPAY-04-01-06-A14") }}</dt>
          <dd class="right">{{ detailInfo.draweRefCtnt1 }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("MPAY-04-01-10-13") }}</dt>
            <dd class="right">{{ detailInfo.draweRefCtnt2 }}</dd>
          </template>
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGAUC">
          <dl class="dlist dlist-item--type6">
            <template v-if="siteCode == $config.SITECODE_OGAUC">
              <dt>{{ /*Reference*/ $t("MPAY-02-01-12-21") }}</dt>
              <dd class="right">{{ detailInfo.draweRefCtnt3 }}</dd>
            </template>
          </dl>
        </template>
        <ul class="ulist ulist-type--bullet">
          <li>{{ /*위의 내용이 정상적으로 처리되었음을 확인합니다. */ $t("MPAY-04-01-06-A15") }}</li>
          <li>{{ /*이체확인증은 고객 편의를 위하여 제공되는 것으로 거래의 참고용으로만 사용될 수 있습니다.*/ $t("MPAY-04-01-06-A16") }}</li>
        </ul>
        <div class="bank-name">
          <template v-if="siteCode == $config.SITECODE_OGHCM">
            <template v-if="operGroupCd == 'VN1'">{{ $t(`${siteCode}_지점명칭`) }}</template>
            <template v-else>{{ $t(`oghni_지점명칭`) }}</template>
          </template>
          <template v-else>{{ $t(`${siteCode}_지점명칭`) }}</template>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="popupClose()">{{ /*확인*/ $t("MPAY-04-01-11-22") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
